export default {"src":"/_next/static/media/SealCheck.221a484b.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};